<template>
    <div>
        <v-navigation-drawer
            v-model="megaMenuDrawer"
            :light="!$vuetify.theme.dark"
            :dark="$vuetify.theme.dark"
            bottom
            app
            temporary
            style="transition: 0.25s; z-index: 998"
            class="pa-4 mega-menu"
        >
            <div class="box pb-15">
                <v-row no-gutters class="px-0 py-0">
                    <v-col
                        v-for="(premiumSportsbook, i) in premiumSportsbookData"
                        :key="i"
                        md="4"
                        sm="3"
                        class="px-0 py-0"
                    >
                        <v-list-item
                            v-if="
                                !$auth.user ||
                                !$auth.user.loggedIn ||
                                $auth.user.premiumsportsbook
                            "
                            :id="premiumSportsbook.name"
                            :key="(premiumSportsbook._id, i)"
                            :to="`/premium-sportsbook?bt-path=${premiumSportsbook.path}`"
                            dense
                            class="d-flex align-items-center justify-content-center px-0"
                        >
                            <v-list-item-avatar
                                tile
                                class="mx-0 mb-1 p-0"
                                :width="$breakpoint.smAndDown ? '35' : '50'"
                            >
                                <v-img
                                    :src="
                                        premiumSportsbook.logo
                                            | newOptimizedImage(
                                                500,
                                                premiumSportsbook.logo
                                            )
                                    "
                                    contain
                                ></v-img>
                            </v-list-item-avatar>
                            {{ premiumSportsbook.name }}
                        </v-list-item>
                    </v-col>
                </v-row>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    data() {
        return {}
    },
    computed: {
        megaMenuDrawer: {
            get() {
                return this.$store.getters["megaMenuDrawer/value"]
            },
            set(v) {
                return this.$store.commit("megaMenuDrawer/toggle", v)
            }
        },
        ...mapState({
            premiumSportsbookData: (state) =>
                state.sportsbookCategory.premiumSportsbookData
        })
    },
    beforeDestroy() {
        this.megaMenuDrawer = false
    }
}
</script>

<style lang="scss">
div.box {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .close-btn {
        position: absolute;
        right: 0.5rem;
        top: 0.5rem;
        z-index: 1000;
        border: none;
    }
    .row {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        font-size: 0.9rem;
        padding: 0.5rem 1rem;
        grid-template-columns: repeat(auto-fill, 100px);
        @media only screen and (max-width: 912px) {
            > div:nth-child(2),
            > div:nth-child(3),
            > div:nth-child(6),
            > div:nth-child(7),
            > div:nth-child(10),
            > div:nth-child(11) {
                border: none;
                // background: red;
                // border-right: 1px solid #454545;
                // border-left: 1px solid #454545;
            }
        }
        @media only screen and (max-width: 767px) {
            display: grid;
            grid-template-columns: repeat(auto-fill, 80px);
            justify-content: space-between;
            padding: 0.5rem;
            font-size: 0.7rem;
            > div:nth-child(3),
            > div:nth-child(6),
            > div:nth-child(7),
            > div:nth-child(10) {
                border: none;
            }
            > div:nth-child(2),
            > div:nth-child(5),
            > div:nth-child(8),
            > div:nth-child(11) {
                // background: red;
                border: none;
                // border-right: 1px solid #454545;
                // border-left: 1px solid #454545;
            }
        }
    }
    .v-list-item {
        position: relative;
        min-height: auto !important;
        &:before {
            opacity: 0;
            // border-right: 1px solid #454545;
            height: 100%;
            width: 1px;
        }
        &:after {
            // border-bottom: 1px solid #454545;
            width: 100%;
            height: 1px;
        }
    }
}
.v-navigation-drawer {
    z-index: 1001 !important;
}

.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
    max-height: calc(100vh - 10vh);
    @media only screen and (max-width: 800px) {
        height: calc(100vh - 100px) !important;
        top: 115px !important;
    }
    height: calc(100vh - 124px) !important;
    background: black;
    a {
        display: flex;
        text-align: center;
        flex-direction: column;
        .game-name {
            font-size: 1.2rem;
            @media only screen and (max-width: 600px) {
                font-size: 1rem;
            }
            line-height: inherit !important;
        }
    }
}
</style>
